import { useEffect, useState } from "react";
import { useParams } from "react-router";

import { WardRosterScreen } from "~/admin/ward-roster-screen";
import { useAuth } from "~/auth/auth-context";
import { getMyWards } from "~/lib/api";
import NotFoundRoute from "~/routes/not-found";

// /admin/wards/:wardId/members — a ward's team roster (V2-E2.2). The roster API
// is admin-gated (the whole `/members` controller is @RequireWardAdmin), so this
// route is reachable only by a super-admin or an admin of this specific ward;
// anyone else gets the 404 page. The ward name is resolved best-effort from the
// caller's own wards (admins are members of the wards they administer) purely for
// the header — the roster itself doesn't depend on it.
export default function AdminWardMembersRoute(): JSX.Element {
  const { wardId } = useParams();
  const { isSuperAdmin, isWardAdmin } = useAuth();
  const [wardName, setWardName] = useState<string | undefined>(undefined);

  const canManage = wardId !== undefined && (isSuperAdmin || isWardAdmin(wardId));

  useEffect(() => {
    if (!wardId) return;
    let cancelled = false;
    void getMyWards().then((result) => {
      if (cancelled) return;
      const match = result.data?.find((w) => w.id === wardId);
      if (match) setWardName(match.name);
    });
    return () => {
      cancelled = true;
    };
  }, [wardId]);

  if (!wardId || !canManage) return <NotFoundRoute />;

  return <WardRosterScreen wardId={wardId} wardName={wardName} canManage={canManage} />;
}
